import LuckyDrawDetailDialog from './luckyDrawDetailDialog.container'

export default LuckyDrawDetailDialog